import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20warm%20artistic%20minimalist%20abstract%20composition%20with%20soft%20organic%20shapes%20and%20flowing%20curves%20in%20warm%20amber%20terracotta%20and%20cream%20tones%2C%20delicate%20textured%20layers%20evoking%20training%20and%20growth%2C%20soft%20diffused%20light%2C%20modern%20art%20style%20with%20gentle%20gradients%20and%20harmonious%20balance&width=1800&height=1200&seq=hero-bg-tiaojiao&orientation=landscape"
        alt="调教指南"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/50"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight">
            专业技能塑造与行为训练完全指南
          </h1>
          <p className="mt-4 md:mt-6 text-base md:text-lg text-white/80 leading-relaxed max-w-2xl mx-auto">
            「调教」是通过系统化方法对技能、行为、习惯进行定向培养与优化的过程。深入解析核心理念、科学方法论与实战技巧，帮助训练师、教育者及自我提升者掌握高效调教策略。
          </p>
          <div className="mt-6 md:mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/pet-training"
              className="whitespace-nowrap px-6 py-3 text-sm font-medium bg-primary-500 text-background-50 rounded-md hover:bg-primary-600 transition-all duration-200 cursor-pointer"
            >
              开始探索
            </Link>
            <Link
              to="/about"
              className="whitespace-nowrap px-6 py-3 text-sm font-medium bg-white/15 text-white border border-white/30 rounded-md hover:bg-white/25 transition-all duration-200 cursor-pointer"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-white/60 text-2xl"></i>
      </div>
    </section>
  );
}